import { render, staticRenderFns } from "./ClosedTrades.vue?vue&type=template&id=74dab271"
import script from "./ClosedTrades.vue?vue&type=script&lang=js"
export * from "./ClosedTrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports